/* app/js/src/components/channel/channel-wizard/step1/substep1.scss */
.cursor-pointer {
  cursor: pointer;
}
input,
textarea {
  height: 30px;
  border-radius: 4px;
  background-color: #ffffff;
  font-size: 12px;
  border: solid 1px #e1e6eb;
  color: #232f3a;
  outline: none;
}
input ::-webkit-input-placeholder,
textarea ::-webkit-input-placeholder {
  color: #c9cdd6;
}
.text {
  color: #232f3a;
}
.text .info {
  margin-top: 25px;
  font-size: 12px;
  color: #879baf;
}
input,
textarea {
  width: 100%;
  padding: 0 12px 0 12px;
  margin-bottom: 17px;
}
input ::-webkit-input-placeholder,
textarea ::-webkit-input-placeholder {
  color: #c9cdd6;
}
textarea {
  resize: none;
  padding-top: 5px;
}
.text-area-large {
  height: 110px;
}
.text {
  margin: 8px 10px 20px 0;
}
.small-dropdown {
  margin-top: 24px;
}
.small-dropdown .small-container {
  display: flex;
  justify-content: space-between;
}
.small-dropdown .small-container .spread {
  width: 100%;
  margin-left: 14px;
}
.small-dropdown .small-container .settingIcon {
  position: relative;
  display: inline;
  top: 3px;
  left: 11px;
  cursor: pointer;
}
.small-dropdown .small-container .settingIcon ::ng-deep svg {
  width: 13px;
  height: 13px;
}
.small-dropdown .small-container .settingIcon ::ng-deep svg path {
  fill: #40c4ff !important;
}
.small-dropdown .bottom-margin-10px {
  margin: 0;
  margin-bottom: 10px;
}
.display-inline {
  display: inline-block !important;
}
.label,
.checkbox-input .label-black {
  color: #879baf;
  padding-right: 12px;
  font-size: 12px;
  display: flex;
}
.subtitles-font-popover {
  width: 365px;
  min-height: 250px;
  height: auto;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  padding: 19px;
}
.subtitles-font-popover header {
  font-family: "Open Sans";
  font-size: 20px;
  font-weight: bold;
}
.subtitles-font-popover .field {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.subtitles-font-popover .field .label,
.subtitles-font-popover .field .checkbox-input .label-black,
.checkbox-input .subtitles-font-popover .field .label-black {
  line-height: 30px;
}
.subtitles-font-popover .field .number-input {
  width: 120px;
  display: inline-flex;
}
.subtitles-font-popover ichannel-button {
  align-self: flex-end;
  margin-top: 10px;
}
.subs-settings {
  width: 371.9px;
  height: 180px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  padding: 19px;
}
.subs-settings header {
  font-size: 20px;
  margin-bottom: 13px;
}
.x-sign {
  cursor: pointer;
}
.triangle-with-shadow {
  width: 17px;
  height: 20px;
  position: absolute;
  overflow: hidden;
  left: -15px;
  top: 66px;
  background-color: transparent;
}
.triangle-with-shadow:after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  transform: rotate(-45deg);
  left: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
}
.checkbox-input {
  background-color: #ffffff;
  position: relative;
  line-height: 30px;
  display: flex;
  width: 100%;
}
.checkbox-input div {
  position: relative;
  border: 1px solid #e1e6eb;
  width: 14px;
  height: 14px;
  cursor: pointer;
  margin-top: 6px;
}
.checkbox-input div svg {
  width: 10px;
  height: 7px;
  position: absolute;
  top: -1px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  fill-opacity: 0;
}
.checkbox-input span {
  white-space: nowrap;
  padding-left: 10px;
}
.checkbox-input input,
.checkbox-input textarea {
  width: 70px;
}
.checkbox-input input.disabled,
.checkbox-input textarea.disabled {
  background-color: #e1e6eb;
}
.checkbox-input .label-black {
  color: #232f3a;
}
.checkbox-input.active div svg {
  fill-opacity: 1;
}
.checkbox-input.readonly div {
  cursor: not-allowed;
}
.disabled {
  background-color: #e1e6eb;
}
.checkbox-input-burn-subs {
  width: auto;
  margin: 0;
}
.label-subs {
  line-height: 28px;
  font-size: 12px;
}
.DVB-comment {
  font-size: 12px;
  color: #7d8fa1;
}
.settingIconSubs {
  top: -23px !important;
  left: 155px !important;
}
.subtitles-choose {
  width: 250px;
  display: flex;
  align-items: center;
}
.header-close-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 28px;
}
.popover-font-dropdown {
  width: 120px !important;
}
.m20 {
  margin-left: 20px;
}
.main-language-field {
  width: 100% !important;
}
.playback-offset-field {
  margin-top: 28px;
  margin-bottom: 34px;
}
.playback-offset-field > icn-number-input {
  display: inline-block;
}
.not-visible {
  visibility: hidden;
}
.use-lufs-field {
  margin-left: 177px;
}
.upload-playlist-settings-fields {
  margin-top: 2vh;
  color: #879baf;
}
.playlist-upload-hours-ahead-field icn-number-input {
  display: inline-block;
}
.scte-command-field {
  display: flex;
  align-items: center;
}
.scte-command-field icn-dropdown {
  width: 170px;
}
.audio-lang-fallback-settings {
  margin-top: 24px;
}
.audio-lang-fallback-settings .rows {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
}
.audio-lang-fallback-settings .audio-lang-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
}
.audio-lang-fallback-settings .audio-lang-row icn-dropdown {
  flex: 0 0 auto;
  width: max-content;
  min-width: 140px;
}
.audio-lang-fallback-settings .audio-lang-row icn-dropdown ::ng-deep ul {
  width: max-content !important;
  min-width: 100%;
  max-width: 360px;
}
.audio-lang-fallback-settings .audio-lang-row icn-dropdown ::ng-deep .selected-container .selected {
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
}
.audio-lang-fallback-settings .audio-lang-row icn-dropdown ::ng-deep .selected-container .selected-multiple {
  flex-wrap: wrap;
}
.audio-lang-fallback-settings .audio-lang-row .fallback-popup-wrapper {
  position: relative;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
}
.audio-lang-fallback-settings .audio-lang-row .fallback-summary-btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  background-color: #ffffff;
  cursor: pointer;
  font-size: 13px;
  color: #232f3a;
  white-space: nowrap;
}
.audio-lang-fallback-settings .audio-lang-row .fallback-summary-btn:hover {
  border-color: #879baf;
}
.audio-lang-fallback-settings .audio-lang-row .fallback-summary-btn .fallback-summary-chevron {
  color: #879baf;
}
.audio-lang-fallback-settings .audio-lang-row .checkbox-input {
  flex: 0 0 auto;
  width: auto;
  white-space: nowrap;
}
.audio-lang-fallback-settings .audio-lang-row .remove-btn {
  flex: 0 0 auto;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  color: #879baf;
  padding: 4px 8px;
}
.audio-lang-fallback-settings .audio-lang-row .remove-btn:hover {
  color: #232f3a;
}
.fallback-popover-content {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 1500;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease-in-out;
  width: 280px;
  background-color: #ffffff;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  padding: 16px;
}
.fallback-popover-content.open {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
}
.fallback-popover-content .fallback-popover-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.fallback-popover-content .fallback-popover-header span {
  font-weight: bold;
  font-size: 14px;
  color: #232f3a;
}
.fallback-popover-content .fallback-popover-close {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  color: #879baf;
  padding: 0 4px;
}
.fallback-popover-content .fallback-popover-close:hover {
  color: #232f3a;
}
.fallback-popover-content .fallback-popover-hint {
  margin: 0 0 10px;
  font-size: 11px;
  color: #879baf;
}
.fallback-popover-content .fallback-chip-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
  min-height: 28px;
}
.fallback-popover-content .fallback-empty {
  font-size: 12px;
  color: #879baf;
  font-style: italic;
  padding: 4px 0;
}
.fallback-popover-content .fallback-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  background-color: #ffffff;
  font-size: 13px;
  color: #232f3a;
  -webkit-user-select: none;
  user-select: none;
  cursor: grab;
}
.fallback-popover-content .fallback-chip:active {
  cursor: grabbing;
}
.fallback-popover-content .fallback-chip.cdk-drag-preview {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 2000;
}
.fallback-popover-content .fallback-chip.cdk-drag-placeholder {
  opacity: 0.4;
  background-color: #e1e6eb;
}
.fallback-popover-content .fallback-chip.cdk-drag-dragging {
  opacity: 0.6;
}
.fallback-popover-content .fallback-chip .drag-handle {
  display: inline-flex;
  align-items: center;
  color: #879baf;
  pointer-events: none;
}
.fallback-popover-content .fallback-chip .drag-handle svg {
  display: block;
}
.fallback-popover-content .fallback-chip .chip-label {
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fallback-popover-content .fallback-chip .chip-remove {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: #879baf;
  padding: 0 2px;
}
.fallback-popover-content .fallback-chip .chip-remove:hover {
  color: #232f3a;
}
.fallback-popover-content .fallback-add-dropdown {
  display: block;
  width: 100%;
}
.fallback-popover-content .fallback-add-dropdown ::ng-deep .selected-container {
  width: 100%;
}
/*# sourceMappingURL=substep1.css.map */
